import { render } from "./PromptObject.vue?vue&type=template&id=0e6264c0"
import script from "./PromptObject.vue?vue&type=script&lang=js"
export * from "./PromptObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__